var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenchmarkFlagLongOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-585 577 27.8 47",
    style: {
      enableBackground: "new -585 577 27.8 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stt0{fill:#FA9917;}\n\t.stt1{fill:#FFFCF5;}\n\t.stt2{fill:#FF7F50;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "stt0",
    d: "M-584,592.9v-13.8c0-0.4,0.3-0.7,0.7-0.7h19.3c0.4,0,0.9,0.2,1.1,0.5l5.5,6.6 c0.2,0.3,0.2,0.7,0,1l-5.5,6.6c-0.3,0.3-0.7,0.5-1.1,0.5h-19.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "stt1",
    d: "M-584.6,623V578c0-0.6,0.3-1,0.7-1c0.4,0,0.7,0.4,0.7,1V623c0,0.6-0.3,1-0.7,1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-3",
    x: -585,
    y: 578.1,
    className: "stt2",
    width: 2.1,
    height: 15.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarkFlagLongOrange);
export default __webpack_public_path__ + "static/media/benchmark-flag-long-orange.3f473243a94555852eef015e18d5df8c.svg";
export { ForwardRef as ReactComponent };